import { useIsEditMode } from "Components/Features/CheckPrice/hooks/checkPriceHooks";
import { CAR_ABOUT_STEP } from ".";

export const useCarStartStep = (): string | undefined => {
  const isEditMode = useIsEditMode();

  return isEditMode ? CAR_ABOUT_STEP.id : undefined;
};
